var $ = require('jquery');

/**
 * Статический класс с различными утилитами
 * @namespace
 */
var Utils = {

    /**
     * Расширяет объект `dest` свойствами объекта `src` и возвращает `dest`.
     *
     * @param {Object} dest Объект, который нужно расширить
     * @param {Object} [object1] Объект, который содержит дополнительные параметры для расширения dest
     * @param {Object} [objectN] Дополнительные объекты, которые содержат дополнительные параметры для расширения dest
     * @returns {Object} dest
     */
    extend: $.extend,

    /**
     * Возвращает функцию, которая вызывает функцию `fn` с контекстом `obj`.
     * @param fn {Function} Функция, к которой нужно привязать контекст
     * @param obj {Object} Объект - контекст. Будет доступен внутри функции как `this`
     * @returns {Function}
     * @example
     *
     * // Допустим у нас есть функция
     * var myFunc = function(){return this.hello};
     *
     * // И простой объект
     * var myContextObject = {hello:'hello world'};
     *
     * // Мы можем создать функцию с привязанным контекстом при этом не удаляя старую функцию myFunc
     * var myFuncWithContextObject = Utils.bind(myFunc, myContextObject);
     *
     * // returns 'hello world'
     * myFuncWithContextObject()
     */
    bind: function(fn, obj){ // (Function, Object) -> Function
        var args = arguments.length > 2 ? Array.prototype.slice.call(arguments, 2) : null;
        return function(){
            return fn.apply(obj, args || arguments);
        };
    },

    /**
     * Stamp
     */
    stamp: (function(){
        var lastId = 0,
            _key   = '_omjs_obj_id';
        return function(obj, key){
            key || (key = _key);
            obj[key] = obj[key] || ++lastId;
            return obj[key];
        };
    }()),

    trim: function(str){
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    },

    splitWords: function(str){
        return Utils.trim(str).split(/\s+/);
    },

    setOptions: function(obj, options){
        obj.options = Utils.extend(true, {}, obj.options, options);
        return obj.options;
    },

    template: function(str, data){
        return str.replace(/\{ *([\w_]+) *\}/g, function(str, key){
            var value = data[key];
            if(value === undefined){
                throw new Error('No value provided for variable ' + str);
            }else if(typeof value === 'function'){
                value = value(data);
            }
            return value;
        });
    },

    invokeEach: function(obj, method, context){
        var i, args;

        if(typeof obj === 'object'){
            args = Array.prototype.slice.call(arguments, 3);

            for(i in obj){
                method.apply(context, [i, obj[i]].concat(args));
            }
            return true;
        }

        return false;
    },

    getUrlWithEndSlash: function(url){
        return url + (url.charAt(url.length - 1) == '/' ? '' : '/');
    },

    flattenTreeObject: function(objects, child_attr, id_attr, parent_value){

        // Если не передали значение родителя - пустая строка. Рут типа.
        parent_value || (parent_value = "");

        objects.forEach(function(obj){
            // Устанавливаем значение родителя
            obj['parent'] = parent_value;

            if(child_attr in obj){ // Объект притворяется, что у него есть потомки

                if(obj[child_attr].length){ // Они действительно есть
                    // Уходим в рекурсию по потомкам объекта
                    // и конкатенируем результат с основным массивом объектов
                    objects = objects.concat(Utils.flattenTreeObject(obj[child_attr],
                        child_attr,
                        id_attr,
                        obj[id_attr]));
                }

                // Удаляем ссылку на потомков из объекта
                delete obj[child_attr]
            }
        });

        // Возвращаем массив объектов
        return objects
    },

    generateColors: function(min_color, max_color, total_colors){
        var R, G, B, i, aRGBStart, aRGBFinish, finishPercent, startPercent,
            /* n - количество промежуточных цветов, включая конечный
             (т.е. между начальным и конечным цветами будет n-1 цвет) */
            n      = total_colors - 1,
            colors = [];

        aRGBStart = min_color.replace("#", "").match(/.{2}/g);
        aRGBFinish = max_color.replace("#", "").match(/.{2}/g);

        for(i = 0; i <= n; i++){

            /*процент содержания конечного цвета в текущем промежуточном цвете;
             изменяется от 0 (не включая 0) до 1 (1 = 100%)*/

            finishPercent = i / n;
            /*процент содержания начального цвета в текущем промежуточном цвете;
             изменяется от 1 до 0 (1 = 100%) */
            startPercent = 1 - finishPercent;

            //вычисляем значения красного, зеленого, синего промежуточного цвета
            R = Math.floor(('0x' + aRGBStart[0]) * startPercent + ('0x' + aRGBFinish[0]) * finishPercent);
            G = Math.floor(('0x' + aRGBStart[1]) * startPercent + ('0x' + aRGBFinish[1]) * finishPercent);
            B = Math.floor(('0x' + aRGBStart[2]) * startPercent + ('0x' + aRGBFinish[2]) * finishPercent);

            colors.push("#" + ((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1));
        }

        return colors;
    },

    getDevicePixelRatio: function () {
        var ratio = 1;
        // To account for zoom, change to use deviceXDPI instead of systemXDPI
        if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
            // Only allow for values > 1
            ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
        }
        else if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        }
        return ratio;
    },

    getZoomFromResolution: function (resolution) {
        var tileSize    = 256,
            worldLength = 20037508.319893047 * 2;

        return Math.log((worldLength) / (tileSize * resolution)) / Math.LN2;
    },

    /**
     * Доработанная функция анимации из https://learn.javascript.ru/js-animation
     * @param options.duration - время анимации в мс
     * @param options.timing - функция анимации (по умолчанию линейная)
     * @param options.infinite - анимация будет длиться бесконечно
     * @param cb - функция, которая будет выполнена в конце анимации. опционально
     * @returns {Function} функция, которая остановит анимацию
     */
    animate: function (options, cb) {
        var start = Date.now();
        var stop  = false;
        options.timing || (options.timing = function (timeFraction) {
            return timeFraction;
        });
        window.requestAnimationFrame(function animate(time) {
            var progress, timeFraction;
            if (stop) {
                if (cb) {
                    cb();
                }
                return false;
            }
            // timeFraction от 0 до 1
            timeFraction = (time - start) / options.duration;
            if (timeFraction > 1) timeFraction = 1;
            if (timeFraction < 0) timeFraction = 0;

            // текущее состояние анимации
            progress = options.timing(timeFraction);

            options.draw(progress);

            if (timeFraction < 1) {
                window.requestAnimationFrame(function () {
                    animate(Date.now())
                });
            } else {
                if (options.infinite) {
                    start = Date.now();
                    window.requestAnimationFrame(function () {
                        animate(Date.now())
                    });
                } else {
                    if (cb) {
                        cb();
                    }
                    return false;
                }
            }
        });

        return function () {
            stop = true;
        }
    },

    webglEnabled: function(){
        var gl;
        var canvas = document.createElement('canvas');
        try {
            gl = canvas.getContext("webgl");
        } catch (x) {
            gl = null;
        }

        if (gl == null) {
            try {
                gl = canvas.getContext("experimental-webgl");
            } catch (x) {
                gl = null;
            }
        }

        return gl != null;
    },

    isTouch: function(){
        var isTouch;
        try {
            document.createEvent("TouchEvent");
            isTouch = true;
        } catch (e) {
            isTouch = false;
        }
        return isTouch;
    },

    emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
    escapeHTML: function(html){
        var escape = document.createElement('div');
        escape.textContent = html;
        return escape.innerHTML;
    },

    unescapeHTML: function(html){
        var escape = document.createElement('div');
        escape.innerHTML = html;
        return escape.textContent;
    },

    doubleUnescapeHTML: function(html){
        return Utils.unescapeHTML(Utils.unescapeHTML(html));
    },
    /**
     *
     * @param number - Кол-во объектов кластера
     * @param scale - Коэффициент масштаба отрисовки (pixelRatio)
     * @param cluserSizeOptions - Параметры отрисовки кол-ва объектов
     * @returns canvas
     */
    createObjectsCountCnv: function(number, scale, cluserSizeOptions) {
        // фигуры иконки кол-ва объектов будут вписаны и отцентрированы в общие размеры
        var width   = cluserSizeOptions.width * scale;
        var height  = cluserSizeOptions.height * scale;
        var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
        // var canvas  = $('<canvas width="'+width+'" height="'+height+'"></canvas>')[0];
        var ctx     = canvas.getContext('2d');

        cluserSizeOptions.figures.forEach(function (fig) {
            var offsetX,
                offsetY;
            switch (fig.type) {
                case 'rect':
                    var rectRadius  = fig.radius * scale,
                        rectWidth   = fig.width * scale,
                        rectHeight  = fig.height * scale,
                        lineWidth   = typeof fig.lineWidth === 'number' ? fig.lineWidth : 1,
                        offset = 0;
                    offsetX = (width - rectWidth) / 2;
                    offsetY = (height - rectHeight) / 2;
                    ctx.strokeStyle = fig.strokeStyle;
                    ctx.fillStyle   = fig.fillStyle;
                    // если есть обводка, то нужен отступ при рисовании,
                    // чтобы обводка за canvas не вылезала (и шла внутрь)
                    if (lineWidth) {
                        ctx.lineWidth   = fig.lineWidth * scale;
                        offset += (ctx.lineWidth / 2);
                    }
                    Utils.roundRect(ctx, offset + offsetX, offset + offsetY,
                        width - ((offset + offsetX) * 2), height - ((offset + offsetY) * 2),
                        rectRadius, true, Boolean(lineWidth));
                    break;
                case 'circle':
                    var circleRadius = fig.radius * scale;
                    offsetX = (width - circleRadius * 2) / 2;
                    offsetY = (height - circleRadius * 2) / 2;
                    ctx.fillStyle   = fig.fillStyle;
                    ctx.beginPath();
                    ctx.arc(circleRadius + offsetX, circleRadius + offsetY, circleRadius, 0, 2 * Math.PI);
                    ctx.fill();
                    // для circle нет нужны поддерживать stroke, эмулиуется circle, бОльшим по размеру
                    break;
            }
        });
        ctx.font        = cluserSizeOptions.fontSize * (scale / 2) + "px " + cluserSizeOptions.fontFamily;
        ctx.textAlign   = cluserSizeOptions.textAlign;
        ctx.textBaseline= cluserSizeOptions.textBaseline;
        ctx.fillStyle   = cluserSizeOptions.textColor;
        ctx.fillText(number, width / 2, (height / 2) + 1); 
        return canvas;
    },

    // https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
    roundRect: function (ctx, x, y, width, height, radius, fill, stroke) {
        if (typeof stroke == 'undefined') {
            stroke = true;
        }
        if (typeof radius === 'undefined' || isNaN(radius)) {
            radius = 5;
        }
        if (typeof radius === 'number') {
            radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
            var defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
            for (var side in defaultRadius) {
                radius[side] = radius[side] || defaultRadius[side];
            }
        }
        ctx.beginPath();
        ctx.moveTo(x + radius.tl, y);
        ctx.lineTo(x + width - radius.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ctx.lineTo(x + width, y + height - radius.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ctx.lineTo(x + radius.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ctx.lineTo(x, y + radius.tl);
        ctx.quadraticCurveTo(x, y, x + radius.tl, y);
        ctx.closePath();
        if (fill) {
            ctx.fill();
        }
        if (stroke) {
            ctx.stroke();
        }
    },

    cloneFeature: function(feature) {
        return feature.clone();
    },

    cloneVectorLayer: function(
        original_layer,
        source_options,
        for_each_feature
    ) {

        var original_style = original_layer.getStyle();

        var cloned_style = null;

        if (_.isArray(original_style)) {
            cloned_style = original_style.map(function(style){
                return style.clone();
            });
        } else if (typeof original_style == 'function') {
            // потенциальное место для ошибок
            cloned_style = original_style.bind(original_style);
        } else {
            cloned_style = original_style.clone();
        }

        var original_source = original_layer.getSource();
        var cloned_features = original_source
                                .getFeatures()
                                .map(Utils.cloneFeature);

        if (
            for_each_feature 
            && _.isFunction(for_each_feature)
        ) {
            for (var i = 0; i < cloned_features.length; i++) {
                var _feature = cloned_features[i];
                for_each_feature(_feature);
            }
        }

        var new_source = new ol.source.Vector(
            _.extend({ features: cloned_features }, source_options)
        );

        var layer = new ol.layer.Vector({
            source: new_source,
            style : cloned_style
        });

        return layer;
    }
};

module.exports = Utils;


//////////////////
// WEBPACK FOOTER
// ./src/~/Utils.js
// module id = 5
// module chunks = 0